import './App.css';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import {AppBar, Toolbar, Typography, IconButton} from '@mui/material';
import {Settings as SettingsIcon} from '@mui/icons-material'
import Home from './pages/Home/Home';
import {Settings} from './parts/Settings/Settings';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {appActions} from './store';

const theme = responsiveFontSizes(createTheme());

const App = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <AppBar position='sticky'>
                    <Toolbar>
                        <Typography variant='h6' flexGrow={1} textAlign='left'>
                            {t('controller_simulator')}
                        </Typography>
                        <IconButton color='inherit' onClick={() => dispatch(appActions.openSettings())}>
                            <SettingsIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Home />
                <Settings />
            </div>
        </ThemeProvider>
    );
};

export default App;
